// AutoGenerated
import { HesapBilgiVeKullaniciModel } from "../businessModels/HesapBilgiVeKullaniciModel"
import { KoroModel } from "../businessModels/KoroModel"

export class KoroVeHesapModel {
    koroModel!: KoroModel;
    hesapModel!: HesapBilgiVeKullaniciModel;
}